import Backbone from 'backbone'
import _ from 'lodash'
import template from './details-tooltip.hbs'
import highlight from 'scoreboard/components/highlight'
import formatValue from 'scoreboard/components/format-value'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType

const blank = () => _.capitalize(`<span class="blank-value">${i18n.get('common.blank')}</span>`)
const DetailsTooltip = Backbone.View.extend({

	/**
	 * Tooltip to display all values (both changed and unchanged) for a metric
	 * update requiring approval on the metric approvals page
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 * @param {Object} options.data - an object holding the information for one
	 * unapproved metric update (corresponds to a row in metric-updates.js)
	 * @param {jQuery|Element} options.attachTo - element the tooltip is
	 * attached to
	 * @param {String} [options.title=i18n.get('common.details')] - title of the
	 * tooltip
	*/
	initialize: function(options) {
		this.options = options || {}
		this.data = this.options.data || {}
		this.createTooltip()
	},

	createTooltip() {
		this.tooltip && this.tooltip.remove()
		let content = template(this.context())
		this.tooltip = new TooltipAndDetails({
			el: this.el,
			selector: this.options.attachTo,
			tooltipContent: () => content
		})
	},

	context() {
		let allValues = this.data.allValues
		let values = _.cloneDeep(allValues)
		// filter out "applicable" if NA option is not displayed
		values = this.filterApplicableIfNaOptionNotShown(values)
		// format values
		_.each(values, value => {
			value.label = this.formatLabel(value.labelCode)
			this.formatOldAndNewValues(value)
		})
		return {
			values,
			title: this.options.title ?? 'common.details'
		}
	},

	filterApplicableIfNaOptionNotShown: function(values) {
		if (!config.showNaOption) {
			values = _.filter(values, v => {
				return !this.representsApplicable(v)
			})
		}
		return values
	},

	formatLabel: function(labelCode) {
		return highlight(labelCode)
	},

	formatOldAndNewValues: function (value) {
		let { dataType, currencyCode, precision } = this.data
		if (this.representsApplicable(value)) {
			dataType = YES_NO
		}
		let options = {dataType, currencyCode, precision, shorten: false}
		value.oldValue = this.getFormattedValueOrBlank(value.oldValue, options)
		value.newValue = this.getFormattedValueOrBlank(value.newValue, options)
	},

	getFormattedValueOrBlank: function(value, options) {
		let val = formatValue(_.extend(options, {value}))
		return val === '' ? blank() : val
	},

	representsApplicable: function (value) {
		return value.labelCode === 'report.updateMetricsReport.applicable'
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tooltip], 'remove')
	}
})
export default DetailsTooltip
DetailsTooltip.__filename__ = 'home/metric-approvals/details-tooltip.js'
